"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractExpInSeconds = exports.serialize = void 0;
var jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
var serialize = function (authState) {
    return jsonwebtoken_1.default.sign(authState, "vtm");
};
exports.serialize = serialize;
var extractExpInSeconds = function (token) {
    var decodedToken = jsonwebtoken_1.default.decode(token);
    if (decodedToken === null) {
        return {
            isValid: false,
            reason: "INVALID_JWT_AT",
        };
    }
    if (typeof decodedToken === "string" || !decodedToken.exp) {
        return {
            isValid: false,
            reason: "MISSING_EXP",
        };
    }
    return {
        isValid: true,
        payload: decodedToken.exp,
    };
};
exports.extractExpInSeconds = extractExpInSeconds;
